function objectEquals (x, y) {
    return (x && y && typeof x === 'object' && typeof y === 'object') 
        ? (Object.keys(x).length === Object.keys(y).length) && 
            Object.keys(x).reduce((isEqual, key) => isEqual && objectEquals(x[key], y[key]), true)
    : (x === y)
};

export default objectEquals